import React from "react";
import { Box } from '@mui/joy';
import { PieTabled } from 'src/mtska-frontend-app-component';
import { useTranslation } from 'react-i18next';
import TableSet from "./RankingCost.TableSet";
import KPISet from "./KPISet";
import JSONPretty from 'react-json-pretty'

const RankingCost = ({ dataProviderName, filters, $key }) => {
    const { t } = useTranslation();

    const showKPI = true;
    const showRankingLead = true;

    return (
        <Box className="dashboard-page" key={$key}>
            <Box className="dashboard-page-title">
                <h2>{t('Leads')}</h2>
            </Box>

            {showKPI &&
                <Box className="report-itemgroup">
                    <KPISet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

            {showRankingLead &&
                <TableSet dataProviderName={dataProviderName} filters={filters} />
            }
        </Box>
    )
}

export default RankingCost;